import type { FilterOption } from '@shared/types/filter.types';

import type {
  GetInstructorsFilterOptionsResult,
  InstructorsFilterOptions,
} from './getInstructorsFilterOptions.types';

export const EMPTY_FILTER_OPTIONS: InstructorsFilterOptions = {
  disciplines: [],
  programs: [],
  locations: [],
};

export function toFilterOptions(values: string[]): FilterOption[] {
  return values.map(value => ({ value, name: value }));
}

export function normalizeFilterOptions(
  data: GetInstructorsFilterOptionsResult | null
): InstructorsFilterOptions {
  if (!data) {
    return EMPTY_FILTER_OPTIONS;
  }
  return {
    disciplines: data.disciplines,
    programs: toFilterOptions(data.programs),
    locations: data.locations,
  };
}
